import type { Ilan } from './ilanlar.ts';

const gorsel = (ad: string) => `/gorseller/${ad}.webp`;

export const ekIlanlar: Ilan[] = [
  {
    id: 'renault-clio-2018',
    baslik: '2020 Renault Clio 1.0 TCe Joy, 116 bin km',
    fiyat: 795000,
    kategori: 'otomotiv',
    altKategori: 'otomobil',
    marka: 'renault',
    model: 'clio',
    gorsel: gorsel('renault-clio'),
    konum: 'İstanbul, Maltepe',
    zaman: '35 dakika önce',
    satici: 'Onur T.',
    durum: 'İkinci el',
    oneCikan: true,
    aciklama:
      'Üç yıldır kullandığım aracımı ihtiyaç değişikliği nedeniyle satıyorum. 116.400 km’de, manuel vites. Yağ ve filtre bakımı 112.000 km’de yapıldı. Klima, hız sabitleyici ve park sensörü çalışıyor. Sağ arka çamurlukta lokal boya var, değişen parça yok. İstediğiniz serviste veya ekspertizde kontrol ettirebiliriz.',
    ozellikler: {
      'Model yılı': '2020',
      Kilometre: '116400',
      Vites: 'Manuel',
      Yakıt: 'Benzin',
      'Kasa tipi': 'Hatchback',
      'Motor hacmi': '0 - 1.3 L',
      Çekiş: 'Önden çekiş',
      'Hasar kaydı': 'Yok',
      Renk: 'Beyaz',
    },
  },
  {
    id: 'fiat-egea-2021',
    baslik: '2021 Fiat Egea 1.3 Multijet Easy',
    fiyat: 895000,
    kategori: 'otomotiv',
    altKategori: 'otomobil',
    marka: 'fiat',
    model: 'egea',
    gorsel: gorsel('fiat-egea'),
    konum: 'Ankara, Çankaya',
    zaman: '1 saat önce',
    satici: 'Hakan A.',
    durum: 'İkinci el',
    takas: true,
    aciklama:
      'Aile içinde kullanılan 1.3 Multijet Egea. 94.800 km’de. Periyodik bakımların faturaları duruyor, muayenesi yeni yapıldı. İki anahtarı da mevcut. Ön tamponda park ederken oluşan küçük sürtme izi var. Aracı hafta içi Çankaya’da görebilirsiniz. Daha küçük bir otomatik araçla takas düşünebilirim.',
    ozellikler: {
      'Model yılı': '2021',
      Kilometre: '94800',
      Vites: 'Manuel',
      Yakıt: 'Dizel',
      'Kasa tipi': 'Sedan',
      'Motor hacmi': '0 - 1.3 L',
      Çekiş: 'Önden çekiş',
      'Hasar kaydı': 'Yok',
      Renk: 'Gri',
    },
  },
  {
    id: 'toyota-corolla-hibrit',
    baslik: '2020 Toyota Corolla 1.8 Hybrid Dream',
    fiyat: 1350000,
    kategori: 'otomotiv',
    altKategori: 'otomobil',
    marka: 'toyota',
    model: 'corolla',
    gorsel: gorsel('toyota-corolla'),
    konum: 'İzmir, Bornova',
    zaman: '2 saat önce',
    satici: 'Pelin K.',
    durum: 'İkinci el',
    oneCikan: true,
    aciklama:
      'İşe gidiş gelişte kullandığımız hibrit Corolla. 82.600 km’de, otomatik vites. Bakımları düzenli yapıldı; son bakım ve hibrit sistem kontrolü belgeleri mevcut. Geri görüş kamerası ve çift bölgeli klima sorunsuz. Boyanan veya değişen parçası yok. Bornova’da görüp test sürüşü yapabilirsiniz.',
    ozellikler: {
      'Model yılı': '2020',
      Kilometre: '82600',
      Vites: 'Otomatik',
      Yakıt: 'Hibrit',
      'Kasa tipi': 'Sedan',
      'Motor hacmi': '1.7 - 2.0 L',
      Çekiş: 'Önden çekiş',
      'Hasar kaydı': 'Yok',
      Renk: 'Gri',
    },
  },
  {
    id: 'volkswagen-golf-2017',
    baslik: '2017 Volkswagen Golf 1.4 TSI Comfortline',
    fiyat: 1050000,
    kategori: 'otomotiv',
    altKategori: 'otomobil',
    marka: 'volkswagen',
    model: 'golf',
    gorsel: gorsel('volkswagen-golf'),
    konum: 'Bursa, Nilüfer',
    zaman: '3 saat önce',
    satici: 'Uğur B.',
    durum: 'İkinci el',
    aciklama:
      '125 beygir, manuel Golf. 128.200 km’de. Debriyaj ve yürüyen aksamda sorun yok, klima bakımı yazın yapıldı. Sol arka kapı boyalı, buna ait hasar kaydı var; belgelerini paylaşabilirim. Dört lastik aynı marka ve 2024 üretimi. Nilüfer’de aracı görebilir, dilediğiniz yerde ekspertiz yaptırabilirsiniz.',
    ozellikler: {
      'Model yılı': '2017',
      Kilometre: '128200',
      Vites: 'Manuel',
      Yakıt: 'Benzin',
      'Kasa tipi': 'Hatchback',
      'Motor hacmi': '1.4 - 1.6 L',
      Çekiş: 'Önden çekiş',
      'Hasar kaydı': 'Var',
      Renk: 'Mavi',
    },
  },
  {
    id: 'honda-civic-2018',
    baslik: '2018 Honda Civic 1.6 i-VTEC Elegance',
    fiyat: 1320000,
    kategori: 'otomotiv',
    altKategori: 'otomobil',
    marka: 'honda',
    model: 'civic',
    gorsel: gorsel('honda-civic'),
    konum: 'Antalya, Muratpaşa',
    zaman: 'Bugün',
    satici: 'Tolga G.',
    durum: 'İkinci el',
    takas: true,
    aciklama:
      'Otomatik Civic, 103.500 km. LPG takılmadı. Sunroof, geri görüş kamerası ve koltuk ısıtmaları çalışıyor. Son bakımda şanzıman yağı da değişti. İki anahtar ve servis kayıtları mevcut. Sağ ön kapıda yüzeysel çizik nedeniyle boya var. Kompakt bir SUV ile takas görüşebiliriz.',
    ozellikler: {
      'Model yılı': '2018',
      Kilometre: '103500',
      Vites: 'Otomatik',
      Yakıt: 'Benzin',
      'Kasa tipi': 'Sedan',
      'Motor hacmi': '1.4 - 1.6 L',
      Çekiş: 'Önden çekiş',
      'Hasar kaydı': 'Yok',
      Renk: 'Beyaz',
    },
  },
  {
    id: 'renault-megane-2018',
    baslik: '2018 Renault Megane 1.5 dCi Touch EDC',
    fiyat: 1065000,
    kategori: 'otomotiv',
    altKategori: 'otomobil',
    marka: 'renault',
    model: 'megane',
    gorsel: gorsel('renault-megane'),
    konum: 'Kocaeli, İzmit',
    zaman: 'Bugün',
    satici: 'Seda E.',
    durum: 'İkinci el',
    aciklama:
      'Büyük bölümü uzun yolda yapılmış 137.000 km’de Megane. EDC şanzıman, 110 beygir dizel motor. Triger seti ve akü geçen yıl değişti. Bakım kayıtları dosya halinde duruyor. Sol ön çamurluk boyalı; fotoğraflarda görülebilen ufak taş izleri var. İzmit merkezde görüp deneyebilirsiniz.',
    ozellikler: {
      'Model yılı': '2018',
      Kilometre: '137000',
      Vites: 'Otomatik',
      Yakıt: 'Dizel',
      'Kasa tipi': 'Sedan',
      'Motor hacmi': '1.4 - 1.6 L',
      Çekiş: 'Önden çekiş',
      'Hasar kaydı': 'Yok',
      Renk: 'Gri',
    },
  },
  {
    id: 'gri-uclu-kanepe',
    baslik: 'Açık gri üçlü kanepe, 215 cm',
    fiyat: 8750,
    kategori: 'ev',
    altKategori: 'mobilya',
    marka: 'markasiz',
    model: 'koltuk',
    gorsel: gorsel('uclu-kanepe'),
    konum: 'İstanbul, Üsküdar',
    zaman: 'Bugün',
    satici: 'Aslı D.',
    durum: 'İkinci el',
    aciklama:
      'Evi küçülttüğümüz için üçlü kanepemizi satıyoruz. 215 cm genişliğinde. Minderler çökmedi, kumaşta yırtık veya leke yok. Ayakları sökülebiliyor. Evde sigara içilmedi. Taşıma alıcıya ait; apartmanda yük asansörü bulunuyor.',
    ozellikler: {
      'Kullanım alanı': 'Salon',
      Malzeme: 'Kumaş',
      Montaj: 'Kurulu',
      Kapasite: '3 kişilik',
      Renk: 'Gri',
    },
  },
  {
    id: 'sehir-bisikleti-28',
    baslik: '28 jant şehir bisikleti, 7 vites',
    fiyat: 5900,
    kategori: 'spor',
    altKategori: 'bisiklet',
    marka: 'yetiskin',
    model: 'sehir-bisikleti',
    gorsel: gorsel('sehir-bisikleti'),
    konum: 'Eskişehir, Tepebaşı',
    zaman: 'Bugün',
    satici: 'Kerem O.',
    durum: 'İkinci el',
    takas: true,
    aciklama:
      'Şehir içinde kullandığım 7 vites bisiklet. L boy alüminyum kadro, 28 jant. Zincir ve fren pabuçları baharda değişti. Çamurlukları ve arka bagajıyla birlikte veriyorum. Selesinde küçük bir aşınma var, sürüşe engel değil. Tepebaşı’nda deneyebilirsiniz.',
    ozellikler: {
      'Jant boyu': '28 inç / 700C',
      'Kadro boyu': 'L',
      'Kadro malzemesi': 'Alüminyum',
      Fren: 'V-fren',
      'Vites sayısı': '7',
      Süspansiyon: 'Yok',
      Renk: 'Siyah',
    },
  },
  {
    id: 'akustik-gitar-kilifli',
    baslik: 'Akustik gitar, kılıfıyla birlikte',
    fiyat: 4250,
    kategori: 'muzik',
    altKategori: 'muzik-aletleri',
    marka: 'gitar',
    model: 'akustik-gitar',
    gorsel: gorsel('akustik-gitar'),
    konum: 'İzmir, Karşıyaka',
    zaman: 'Dün',
    satici: 'Derya Y.',
    durum: 'İkinci el',
    aciklama:
      'Başlangıç için aldığım çelik telli akustik gitar. Sapı düz, perde veya akort sorunu yok. Telleri yakın zamanda yeniledim. Gövdede ışıkta görülen ince kullanım izleri bulunuyor. Kılıfını da yanında vereceğim. Karşıyaka’da elden teslim edebilirim.',
    ozellikler: {
      'Tel sayısı': '6',
      Yön: 'Sağ el',
      Gövde: 'Lamine',
      'Kılıf / hardcase': 'Var',
      Renk: 'Doğal',
      Kutu: 'Yok',
      Fatura: 'Yok',
      Garanti: 'Süresi doldu',
    },
  },
  {
    id: 'kabin-boy-bebek-arabasi',
    baslik: 'Kabin boy bebek arabası, antrasit',
    fiyat: 3200,
    kategori: 'anne-bebek',
    altKategori: 'tasima',
    marka: 'bebek-arabasi',
    model: 'kabin-boy',
    gorsel: gorsel('bebek-arabasi'),
    konum: 'Ankara, Yenimahalle',
    zaman: 'Dün',
    satici: 'İpek S.',
    durum: 'İkinci el',
    aciklama:
      'Çocuğumuz büyüdüğü için artık kullanmıyoruz. Tek elle katlanıyor; kendi ağırlığı 6,5 kg. Kumaşını ve emniyet kemerlerini temizledim. Tekerlek ve frenleri sorunsuz. Yağmurluğu da yanında. Taşıma sırasında oluşan küçük çerçeve çizikleri var.',
    ozellikler: {
      'Taşıma kapasitesi': '22 kg',
      Katlanma: 'Tek elle',
      'Çift yönlü oturma': 'Yok',
      'Tam yatış': 'Var',
      'Portbebe dahil': 'Yok',
      Yağmurluk: 'Var',
      Renk: 'Gri',
      Kutu: 'Yok',
      Fatura: 'Var',
      Garanti: 'Süresi doldu',
    },
  },
  {
    id: 'ev-tipi-espresso-makinesi',
    baslik: 'Ev tipi espresso makinesi, çelik gövde',
    fiyat: 6800,
    kategori: 'ev',
    altKategori: 'kucuk-ev-aletleri',
    marka: 'pisirme',
    model: 'kahve-makinesi',
    gorsel: gorsel('espresso-makinesi'),
    konum: 'İstanbul, Kadıköy',
    zaman: 'Dün',
    satici: 'Efe M.',
    durum: 'İkinci el',
    aciklama:
      'İki yıldır evde kullandığım yarı otomatik espresso makinesi. Portafiltre, tek ve çift fincan sepetleriyle verilecek. Buhar çubuğu çalışıyor, kireç temizliği düzenli yapıldı. Damla tepsisinde günlük kullanıma bağlı çizikler var. Öğütücü dahil değil. Gelince kahve yapıp deneyebiliriz.',
    ozellikler: {
      'Kahve türü': 'Espresso',
      Çalışma: 'Yarı otomatik',
      Öğütücü: 'Yok',
      'Süt köpürtücü': 'Var',
      Renk: 'Gümüş',
      Kutu: 'Yok',
      Fatura: 'Var',
      Garanti: 'Süresi doldu',
    },
  },
  {
    id: 'frontend-gelistirici-is',
    baslik: 'Kadıköy’de hibrit çalışacak frontend geliştirici',
    fiyat: 0,
    fiyatGorusulur: true,
    kategori: 'is-ilanlari',
    altKategori: 'bilisim-yazilim',
    marka: 'yazilim',
    model: 'frontend-gelistirici',
    gorsel: gorsel('yazilim-is'),
    konum: 'İstanbul, Kadıköy',
    zaman: 'Bugün',
    satici: 'Ada S.',
    durum: 'Sıfır',
    aciklama:
      'Ürün ekibimizde React ve TypeScript ile çalışacak frontend geliştirici arıyoruz. En az bir web projesini yayına almış, responsive arayüzler üzerinde çalışmış olmanızı bekliyoruz. Haftada iki gün Kadıköy’deki ofiste, üç gün uzaktan çalışıyoruz. Başvururken GitHub profilinizi veya üzerinde çalıştığınız bir projeyi paylaşabilirsiniz. Ücret aralığı ve yan hakları ilk görüşmede konuşacağız.',
    ozellikler: {
      'Çalışma şekli': 'Tam zamanlı',
      'Çalışma yeri': 'Hibrit',
      Deneyim: '1 - 2 yıl',
      Eğitim: 'Lisans',
      'Ücret dönemi': 'Aylık',
      'Yan haklar': 'Yemek ve yol',
      'Yabancı dil': 'İngilizce',
      'Yabancı dil seviyesi': 'İyi',
      'Açık pozisyon sayısı': '1',
      Vardiya: 'Gündüz',
      Kıdem: 'Orta seviye',
    },
  },
  {
    id: 'barista-is-ilani',
    baslik: 'Kafemiz için tam zamanlı barista',
    fiyat: 0,
    fiyatGorusulur: true,
    kategori: 'is-ilanlari',
    altKategori: 'restoran-konaklama',
    marka: 'servis',
    model: 'barista',
    gorsel: gorsel('barista-is'),
    konum: 'İzmir, Konak',
    zaman: 'Bugün',
    satici: 'Baran E.',
    durum: 'Sıfır',
    aciklama:
      'Konak’taki kafemizde kahve hazırlama ve bar düzeninden sorumlu olacak ekip arkadaşı arıyoruz. Espresso makinesi kullanmış ve temel süt köpürtme deneyimi olan adaylarla görüşmek isteriz. Çalışma saatleri vardiyalı, haftada bir gün izin var. Ücret, yemek ve vardiya düzenini görüşmede ayrıntılı olarak paylaşacağız.',
    ozellikler: {
      'Çalışma şekli': 'Tam zamanlı',
      'Çalışma yeri': 'İş yerinde',
      Deneyim: '1 - 2 yıl',
      Eğitim: 'Lise',
      'Ücret dönemi': 'Aylık',
      'Yan haklar': 'Yemek ve yol',
      'Yabancı dil': 'Aranmıyor',
      'Açık pozisyon sayısı': '1',
      Vardiya: 'Vardiyalı',
    },
  },
  {
    id: 'yazilim-test-uzmani-is',
    baslik: 'Uzaktan çalışacak yazılım test uzmanı',
    fiyat: 0,
    fiyatGorusulur: true,
    kategori: 'is-ilanlari',
    altKategori: 'bilisim-yazilim',
    marka: 'yazilim',
    model: 'test-uzmani',
    gorsel: gorsel('yazilim-is'),
    konum: 'Ankara, Çankaya',
    zaman: 'Dün',
    satici: 'Ceren A.',
    durum: 'Sıfır',
    aciklama:
      'Web ve mobil uygulamalarımız için test senaryoları hazırlayacak, hataları tekrar üretip ekiple paylaşacak test uzmanı arıyoruz. Manuel test deneyimi bekliyoruz; otomasyon deneyimi varsa başvurunuzda belirtebilirsiniz. Türkiye’den uzaktan çalışma mümkün. Mesai saatleri ve ücret aralığı ilk görüşmede paylaşılacak.',
    ozellikler: {
      'Çalışma şekli': 'Tam zamanlı',
      'Çalışma yeri': 'Uzaktan',
      Deneyim: '1 - 2 yıl',
      Eğitim: 'Lisans',
      'Ücret dönemi': 'Aylık',
      'Yan haklar': 'Yemek',
      'Yabancı dil': 'İngilizce',
      'Yabancı dil seviyesi': 'İyi',
      'Açık pozisyon sayısı': '1',
      Vardiya: 'Gündüz',
      Kıdem: 'Orta seviye',
    },
  },
  {
    id: 'bostanci-kiralik-daire',
    baslik: 'Bostancı’da Marmaray’a yakın, boş 2+1 daire',
    fiyat: 32500,
    kategori: 'emlak',
    altKategori: 'konut',
    marka: 'kiralik',
    model: 'daire',
    gorsel: gorsel('kiralik-daire'),
    konum: 'İstanbul, Kadıköy',
    zaman: 'Bugün',
    satici: 'Pelin K.',
    durum: 'İkinci el',
    aciklama:
      'Bostancı’da, Marmaray istasyonuna yürüyerek yaklaşık 8 dakika mesafedeki dairemiz kiralık. İkinci katta, brüt 95, net 80 m². Salon ve mutfak ayrı, kapalı balkonu var. Daire boş; boya ve temizlik yapıldı. Isınma doğal gaz kombiyle. Binada asansör bulunuyor, otopark yok. Bir kira bedeli depozito isteniyor. Görmek için mesajla uygun olduğunuz günü yazabilirsiniz.',
    ozellikler: {
      'Brüt alan': '95',
      'Net alan': '80',
      'Oda sayısı': '2+1',
      'Bina yaşı': '11 - 15',
      'Kat sayısı': '5',
      'Bulunduğu kat': '2',
      'Banyo sayısı': '1',
      Isıtma: 'Kombi (doğal gaz)',
      'Tapu durumu': 'Kat mülkiyetli',
      'Kullanım durumu': 'Boş',
      Asansör: 'Evet',
      Otopark: 'Yok',
      Balkon: 'Evet',
      Eşyalı: 'Hayır',
      'Site içerisinde': 'Hayır',
    },
  },
  {
    id: 'karsiyaka-su-tesisati',
    baslik: 'Karşıyaka’da musluk, sifon ve su tesisatı tamiri',
    fiyat: 0,
    fiyatGorusulur: true,
    kategori: 'hizmetler',
    altKategori: 'tadilat-dekorasyon',
    marka: 'tesisat',
    model: 'su-tesisati',
    gorsel: gorsel('tesisat-hizmeti'),
    konum: 'İzmir, Karşıyaka',
    zaman: 'Bugün',
    satici: 'Hakan A.',
    durum: 'Sıfır',
    aciklama:
      'Karşıyaka ve çevresinde musluk değişimi, rezervuar tamiri, lavabo gideri ve küçük tesisat işleri yapıyorum. Randevu almadan önce sorunun fotoğrafını mesajla gönderebilirsiniz. İşçilik ve gerekiyorsa malzeme bedelini işe başlamadan paylaşıyorum. Hafta içi ve cumartesi çalışıyorum. Doğal gaz ve elektrik işi yapmıyorum.',
    ozellikler: {
      'Hizmet yeri': 'Müşterinin adresinde',
      Ücretlendirme: 'Teklif usulü',
      Deneyim: '10 yıldan fazla',
      'Hizmet zamanı': 'Randevuyla',
      'Hizmet bölgesi': 'İlçe genelinde',
      Kapsam: 'Keşif sonrası',
      'Ücretsiz keşif': 'Hayır',
      'İşçilik garantisi': 'Evet',
      'Malzeme temini': 'Evet',
    },
  },
  {
    id: 'alti-kitap-roman-seti',
    baslik: 'Kitaplığımı azaltıyorum, 6 roman birlikte',
    fiyat: 480,
    kategori: 'kitap',
    altKategori: 'edebiyat',
    marka: 'kurmaca',
    model: 'roman',
    gorsel: gorsel('kitap-seti'),
    konum: 'Ankara, Çankaya',
    zaman: 'Dün',
    satici: 'Derya Y.',
    durum: 'İkinci el',
    aciklama:
      'Kitaplıkta yer açmak için fotoğraftaki altı romanı birlikte satıyorum. Tamamı Türkçe, karton kapak. Sayfalarda not veya alt çizme yok; kapak kenarlarında hafif kullanım izi var. İsterseniz kitapların listesini ve tek tek fotoğraflarını mesajla gönderebilirim. Çankaya’da elden teslim edebilir ya da alıcı ödemeli kargolayabilirim.',
    ozellikler: {
      Dil: 'Türkçe',
      Cilt: 'Karton kapak',
      'Sayfa durumu': 'Temiz',
      'Baskı yılı': '2015 - 2019',
      'Satış şekli': 'Set',
    },
  },
  {
    id: 'ahsap-satranc-takimi',
    baslik: 'Katlanır ahşap satranç takımı, eksiksiz',
    fiyat: 950,
    kategori: 'hobi',
    altKategori: 'kutu-oyunlari',
    marka: 'klasik',
    model: 'satranc',
    gorsel: gorsel('hobi-satranc'),
    konum: 'Bursa, Nilüfer',
    zaman: 'Dün',
    satici: 'Uğur B.',
    durum: 'İkinci el',
    aciklama:
      'Evde kullandığımız ahşap satranç takımı. Açık halde yaklaşık 40 × 40 cm; kapanınca taşlar içinde saklanıyor. 32 taşın tamamı mevcut, altlarında keçe var. Tahtanın kenarında küçük bir çizik dışında sorunu yok. Nilüfer’de elden teslim edebilirim.',
    ozellikler: {
      'Oyuncu sayısı': '2',
      Yaş: '6+',
      Dil: 'Dilden bağımsız',
      'Eksik parça': 'Yok',
      'Oyun kılavuzu': 'Yok',
      Kutu: 'Yok',
    },
  },
  {
    id: '18v-akulu-matkap-seti',
    baslik: '18 V akülü matkap, çift akü ve taşıma çantası',
    fiyat: 2750,
    kategori: 'bahce',
    altKategori: 'el-aletleri',
    marka: 'elektrikli',
    model: 'matkap',
    gorsel: gorsel('akulu-matkap'),
    konum: 'Kocaeli, İzmit',
    zaman: '2 gün önce',
    satici: 'Onur T.',
    durum: 'İkinci el',
    aciklama:
      'Evde raf ve dolap montajında kullandığım 18 V matkap. İki adet 2 Ah akü, şarj cihazı ve çantasıyla verilecek. Aküler şarj tutuyor; mandren ve vites geçişleri sorunsuz. Darbeli değil. Fotoğraftaki uçları da vereceğim. Alırken çalıştırıp deneyebilirsiniz.',
    ozellikler: {
      'Güç kaynağı': 'Akülü',
      'Akü gerilimi': '18 V',
      'Akü kapasitesi': '2 Ah',
      Mandren: '13 mm',
      'Azami tork': '40 - 59 Nm',
      Darbeli: 'Yok',
      'Şarj cihazı dahil': 'Var',
      'Taşıma çantası': 'Var',
      Kutu: 'Yok',
      Fatura: 'Var',
      Garanti: 'Süresi doldu',
    },
  },
  {
    id: 'sac-kurutma-2200w',
    baslik: '2200 W saç kurutma makinesi, başlığıyla',
    fiyat: 650,
    kategori: 'kisisel-bakim',
    altKategori: 'sac-bakimi',
    marka: 'sekillendirme',
    model: 'sac-kurutma',
    gorsel: gorsel('sac-kurutma'),
    konum: 'İstanbul, Beşiktaş',
    zaman: '2 gün önce',
    satici: 'Aslı D.',
    durum: 'İkinci el',
    aciklama:
      'Yeni bir şekillendirici aldığım için kurutma makinemi satıyorum. 2200 W, iki hız ve üç sıcaklık ayarı var. Soğuk üflemesi ve tüm kademeleri çalışıyor. Dar kurutma başlığı yanında; kablosunda veya fişinde sorun yok. Filtresini temizledim. Kutusu bulunmuyor.',
    ozellikler: {
      'Güç kaynağı': 'Priz',
      Güç: '2000 W ve üzeri',
      'Sıcaklık ayarı': 'Var',
      'Başlık sayısı': '1',
      Renk: 'Siyah',
      Kutu: 'Yok',
      Fatura: 'Yok',
      Garanti: 'Süresi doldu',
    },
  },
  {
    id: 'dijital-multimetre-problu',
    baslik: 'Dijital multimetre, ölçüm probları dahil',
    fiyat: 850,
    kategori: 'teknik-elektronik',
    altKategori: 'olcu-test',
    marka: 'elektrik',
    model: 'multimetre',
    gorsel: gorsel('dijital-multimetre'),
    konum: 'Eskişehir, Tepebaşı',
    zaman: '2 gün önce',
    satici: 'Kerem O.',
    durum: 'İkinci el',
    aciklama:
      'Elektronik hobi işlerimde kullandığım dijital multimetre. Gerilim, akım, direnç ve süreklilik ölçümü yapıyor. Ekranı ve kademe anahtarı sorunsuz. Kırmızı ve siyah problarıyla verilecek. Kalibrasyon belgesi yok. Tepebaşı’nda elden teslimde birlikte deneyebiliriz.',
    ozellikler: {
      Ölçüm: 'Dijital',
      'Ölçüm türü': 'Çok işlevli',
      'Kalibrasyon belgesi': 'Yok',
      'Prob dahil': 'Var',
      Kutu: 'Yok',
      Fatura: 'Yok',
      Garanti: 'Süresi doldu',
    },
  },
  {
    id: 'fileli-calisma-koltugu',
    baslik: 'File sırtlı çalışma koltuğu, ayarlanabilir kolçak',
    fiyat: 3250,
    kategori: 'ofis',
    altKategori: 'ofis-mobilyasi',
    marka: 'oturma',
    model: 'ofis-koltugu',
    gorsel: gorsel('ofis-sandalyesi'),
    konum: 'İstanbul, Üsküdar',
    zaman: '3 gün önce',
    satici: 'Emre B.',
    durum: 'İkinci el',
    aciklama:
      'Evden çalışırken kullandığım koltuğumu satıyorum. Yükseklik, kolçak ve sırt eğimi ayarlanabiliyor. Amortisörü kaçırmıyor, tekerlekleri sağlam. Oturma minderinde çökme veya yırtık yok. Kolçak üstlerinde hafif kullanım izi var. Kurulu şekilde Üsküdar’dan alınabilir.',
    ozellikler: {
      Malzeme: 'Plastik',
      Döşeme: 'File',
      'Yükseklik ayarı': 'Var',
      Kolçak: 'Var',
      'Bel desteği': 'Var',
      Renk: 'Gri',
    },
  },
  {
    id: 'ahsap-kasali-eski-radyo',
    baslik: 'Ahşap kasalı eski radyo, dekoratif',
    fiyat: 4750,
    kategori: 'antika',
    altKategori: 'antika-obje',
    marka: 'gunluk',
    model: 'antika-radyo',
    gorsel: gorsel('antika-radyo'),
    konum: 'İstanbul, Bakırköy',
    zaman: '3 gün önce',
    satici: 'Ömer E.',
    durum: 'İkinci el',
    aciklama:
      'Aileden kalan ahşap kasalı radyo. Uzun zamandır dekoratif olarak duruyor, elektrik bağlantısını deneyip çalıştırmadım. Kasası ve ön kumaşı fotoğraflardaki durumda; yüzeyde yaşına bağlı ince izler var. Üretim yılına ve çalışmasına dair garanti veremiyorum. İçini görmek isteyenlere ayrıntılı fotoğraf gönderebilirim. Kırılma riski nedeniyle elden teslim tercih ediyorum.',
    ozellikler: {
      Malzeme: 'Ahşap',
      Menşei: 'Bilinmiyor',
      Dönem: 'Bilinmiyor',
      Kondisyon: 'Kullanım izi var',
      'Belge / sertifika': 'Yok',
    },
  },
];
